export const CalendarDateRange = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="22" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M5 11H27" stroke="currentColor" stroke-width="2"/>
<path d="M21 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M11 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M10.1863 19L22 19" stroke="currentColor" stroke-width="2"/>
<path d="M19.2984 15.5774L22.7176 19.0021L19.2825 22.4225" stroke="currentColor" stroke-width="2"/>
<path d="M12.7016 22.4226L9.28244 18.9979L12.7175 15.5775" stroke="currentColor" stroke-width="2"/>
</svg>`;
